// import { addError } from './error';
// import api from '../../helpers/ApiClient';

export const ADD_CART_ITEM = 'ADD_CART_ITEM';
export const ADD_CART_ITEMS = 'ADD_CART_ITEMS';
export const EDIT_CART_ITEM = 'EDIT_CART_ITEM';
export const REMOVE_CART_ITEM = 'REMOVE_CART_ITEM';
export const CLEAR_CART = 'CLEAR_CART';

export function addCartItem(item) {
  return {
    type: ADD_CART_ITEM,
    payload: {
      item: item,
    }
  };
}

export function addCartItems(items, file) {
  return {
    type: ADD_CART_ITEMS,
    payload: {
      items,
      file
    }
  };
}

export function editCartItem(articleNumber, quantity) {
  return {
    type: EDIT_CART_ITEM,
    payload: {
      articleNumber,
      quantity: parseInt(quantity, 10)
    }
  };
}

export function removeCartItem(articleNumber) {
  return {
    type: REMOVE_CART_ITEM,
    payload: {
      articleNumber,
    }
  };
}

export function clearCart() {
  return {
    type: CLEAR_CART,
  };
}